export default __webpack_public_path__ + "static/media/alexanderbrasserie_thumb.6a3ae1ce.jpg";